import CdnRepositoryRemote from '../api/CdnRepositoryRemote';
import { CdnRepository } from '../api/interfaces/CdnRepository';
import { BrandColors, MultiLingualStylesheet, Stylesheet } from '../interfaces/Stylesheet';

export default class StylesheetService {
  private repository: CdnRepository;

  constructor() {
    this.repository = new CdnRepositoryRemote();
  }

  public async getGlobalStylesheet(): Promise<MultiLingualStylesheet> {
    return await this.getStylesheet(
      import.meta.env.VITE_GLOBAL_STYLESHEET
    );
  }

  public async getStylesheet(subscriptionId: string): Promise<MultiLingualStylesheet> {
    const stylesheet = await this.repository.getStylesheet(subscriptionId);

    return stylesheet;
  }
}

export const getActiveStylesheet = (
  globalStylesheet: MultiLingualStylesheet,
  brandStylesheet: MultiLingualStylesheet | undefined,
  language: keyof MultiLingualStylesheet
): Stylesheet => {
  return brandStylesheet?.[language] || globalStylesheet[language];
};

export const getBrandColors = (stylesheet: Stylesheet): BrandColors => {
  return stylesheet.settings.colors ?? {
    primary: '#13161A',
    secondary: '#13161A',
    background: '#E9EEF2',
  };
};

export const getBrandColorsUriEncoded = (stylesheet: Stylesheet): BrandColors => {
  const { primary, secondary, background } = getBrandColors(stylesheet);

  return {
    primary: encodeURIComponent(primary),
    secondary: encodeURIComponent(secondary),
    background: encodeURIComponent(background),
  };
};
